import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ArtikelAdmin, Material, MaterialApi, WarengruppeApi } from './material';
import { Observable } from 'rxjs';
import { Supplier } from '../supplier/supplier';
import { UnitApi } from './unit';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';

@Injectable()
export class MaterialService {
    constructor(
        private readonly http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    public getOne(id: number): Observable<Material> {
        return this.http.get<Material>(this.apiBaseUrl + 'artikel/read_one.php?artikel_id=' + id);
    }

    public searchMaterial(searchString: string): Observable<MaterialApi> {
        return this.http.get<MaterialApi>(this.apiBaseUrl + 'artikel/read.php?search=' + searchString + '&limit=10');
    }

    public searchSupplierMaterial(searchString: string, supplier?: Supplier): Observable<MaterialApi> {
        let params: HttpParams = new HttpParams().set('search', searchString).set('limit', '10');

        if (supplier) {
            params = params.append('lieferant_id', supplier.lieferant_id.toString());
        }

        return this.http.get<MaterialApi>(this.apiBaseUrl + 'artikel/read_mit_lieferant.php', { params: params });
    }

    public getMaterialByEAN(ean: string): Observable<MaterialApi> {
        return this.http.get<MaterialApi>(this.apiBaseUrl + 'artikel_autocomplete/read.php?ean=' + ean);
    }

    public getUnits(): Observable<UnitApi> {
        return this.http.get<UnitApi>(this.apiBaseUrl + 'einheit/read.php');
    }

    public loadAdminMaterial(id: number): Observable<ArtikelAdmin> {
        return this.http.get<ArtikelAdmin>(this.apiBaseUrl + 'artikel_admin/read_one.php?artikel_id=' + id);
    }

    public saveAdminMaterial(aa: ArtikelAdmin): Observable<ArtikelAdmin> {
        return this.http.post<ArtikelAdmin>(this.apiBaseUrl + 'artikel_admin/update.php', aa);
    }

    getWarengruppen(): Observable<WarengruppeApi> {
        return this.http.get<WarengruppeApi>(this.apiBaseUrl + 'warengruppe/read.php');
    }
}
